module.exports = __webpack_public_path__ + "static/media/lte1.4b2f4b87.jpg";